import { Table, TableContainer, TableHead, TableRow, TableCell, TableBody, Box, IconButton } from '@mui/material';
import { SxProps, Theme } from '@mui/material';
import { ProductRecommendationsSummary } from './product-recommendations-summary';
import { useQuoteState } from 'shared/contexts';
import { ProductRecommendationLookup } from 'shared/types';
import { AddCircleOutline, CheckCircle } from '@mui/icons-material';
import { useCallback } from 'react';

const rootStyles: SxProps<Theme> = {
  width: '100%',
};
const productRecommendationssStyles: SxProps<Theme> = (theme: Theme) => ({
  marginTop: '20px',
  width: '100%',
  '& .MuiTableRow-head': {
    backgroundColor: theme.palette.background.paper,
  },
  '& .MuiTableCell-head': {
    fontWeight: 'normal',
    '&:nth-of-type(1)': {
      paddingLeft: theme.spacing(5),
    },
  },
});

interface ProductRecommendationsDetailsProps {
  data: ProductRecommendationLookup[];
}

export function ProductRecommendationsDetails({ data }: ProductRecommendationsDetailsProps) {
  const { editMode, recommendationsSelected, setRecommendationsSelected } = useQuoteState();

  const handleChange = useCallback(() => {
    if (recommendationsSelected.length < data.length) {
      setRecommendationsSelected(data);
    } else {
      setRecommendationsSelected([]);
    }
  }, [setRecommendationsSelected, recommendationsSelected, data]);

  return (
    <Box sx={rootStyles}>
      <Box sx={productRecommendationssStyles}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                {editMode && (
                  <TableCell align='left'>
                    <IconButton onClick={handleChange}>
                      {recommendationsSelected.length === data.length ? (
                        <CheckCircle color='success' />
                      ) : (
                        <AddCircleOutline color='primary' />
                      )}
                    </IconButton>
                  </TableCell>
                )}
                <TableCell align='left'>Product</TableCell>
                <TableCell align='left'>Product Number</TableCell>
                <TableCell align='left'>Last Purchase Date</TableCell>
                <TableCell align='left'>Cost</TableCell>
                <TableCell align='left'>Customer Tier Sales TTM</TableCell>
                <TableCell align='left'>Reason</TableCell>
                <TableCell align='right' />
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((productRecommendation, index) => (
                <ProductRecommendationsSummary
                  key={productRecommendation.uniqueid}
                  productRecommendation={productRecommendation}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
}
